/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
const r = {}, n = (t) => String(t).trim().split(" "), l = (t, s) => {
  const e = n(s);
  return !!n(t.className).find((i) => e.indexOf(i) >= 0);
}, a = (t) => (s) => l(s, t), f = (t) => (r[t] || (r[t] = (s) => String(s.nodeName).toLowerCase() === t.toLowerCase()), r[t]), c = (t, s, e = !0) => {
  if (t) {
    if (e && s(t))
      return t;
    for (t = t.firstChild; t; ) {
      if (t.nodeType === 1) {
        const i = c(t, s);
        if (i)
          return i;
      }
      t = t.nextSibling;
    }
  }
};
export {
  c as findElement,
  l as hasClasses,
  a as matchesClasses,
  f as matchesNodeName
};
